import Route from '@ember/routing/route';
import type GroupInviteRegistration from 'invite-sign/models/group-invite-registration';
import type { GroupInviteLinkRouteModel } from 'invite-sign/routes/group-invite';

export interface GroupInviteLinkShowFillRouteModel extends GroupInviteLinkRouteModel {
  registration: GroupInviteRegistration;
}

export default class GroupInviteLinkShowFillRoute extends Route {
  async model(): Promise<GroupInviteLinkShowFillRouteModel> {
    const { groupInviteLink, location } = <GroupInviteLinkRouteModel>this.modelFor('group-invite');

    // Explicit null check - groupInviteLink is required to create a registration
    if (!groupInviteLink) {
      throw new Error(
        'GroupInviteLink is required to create a registration. The parent route may have failed to load the group invite link.',
      );
    }

    // TypeScript now knows groupInviteLink is defined
    const registration = await groupInviteLink.createRegistration();

    return {
      groupInviteLink,
      location,
      registration,
    };
  }
}
